<style scoped lang="less">
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <el-input size="mini" style="width: 200px;" placeholder="关键字" clearable @clear="refetchData"
                prefix-icon="el-icon-search" v-model="keyword" @keyup.native.enter="refetchData"></el-input>
            <el-button size="mini" class="margin-l" type="primary" @click.stop="refetchData">搜索</el-button>
            <el-button size="mini" type="success" @click.stop="addOrEdit(null)">新增</el-button>
        </div>

        <paged-table ref="table" @fetch-data="fetchData" class="block-mini-top">
            <el-table slot :data="data" border size="mini">
                <el-table-column label="店名" align="center" prop="name" width="200"></el-table-column>
                <el-table-column label="备注" align="center" prop="remarks" width="200"></el-table-column>

                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button class="super-mini-button" type="primary" size="mini"
                            @click.stop="addOrEdit(scope.row)">编辑</el-button>
                        <el-button class="super-mini-button" type="danger" size="mini"
                            @click.stop="removeModel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </paged-table>

        <dialog-edit-store ref="edit" @fetch-data="fetchData"></dialog-edit-store>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable";
import { HttpClient } from "../util/http";

import DialogEditStore from "../components/dialog/dialogEditStore";
import { removeModel } from "../util/restful";
import { actionConfirm, msgSuccess } from "../util/toast";

export default {
    components: {
        DialogEditStore,
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            data: [],
            keyword: "",
        };
    },
    created() {},
    computed: {
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
    },
    mounted() {},
    methods: {
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            let cond = {};
            if (this.keyword) {
                const regex = {
                    $regex: this.keyword,
                    $options: "i",
                };
                cond["$or"] = [
                    {
                        name: regex,
                    },
                    {
                        remarks: regex,
                    },
                ];
            }
            let res = await HttpClient.post("/restful", {
                model: "Store",
                cond,
                sort: {
                    _id: -1,
                },
                pageSize: this.table.pageSize,
                pageNum: this.table.pageNum,
                withCount: true,
            });
            this.data = res.result;
            this.table.submitTotal(res.count);
        },
        addOrEdit(item) {
            this.edit.addOrEdit(item);
        },
        async removeModel(item) {
            await actionConfirm();
            await removeModel("Store", item._id);
            msgSuccess();
            this.refetchData();
        },
    },
};
</script>
